import { Close } from '@mui/icons-material';
import { Button, Box } from '@mui/material';
import React from 'react';

export default function Hint(props) {

    return(
        <Box sx={{position: "relative", width: props.fitContent ? "fit-content" : "auto"}}>
            <Button sx={{position: "absolute", top:5 , right: 5}} onClick={props.handleHintClosed} endIcon={<Close/>}>
                Schließen
            </Button>
            {props.hint}
        </Box>
    )
}